import React, { useState, useEffect } from "react";

import { useData } from "../../utils/dataProvider";
import "./style.scss";
import { useParams } from "react-router-dom";
import axios from "axios";
import { url } from "../../utils/config";
import Car from "../../assets/car.png";
import Mail from "../../assets/mail.png";
import Sign from "../../assets/sign.png";

export default function Finish() {
    const { page, setPage } = useData();
    const { id } = useParams();
    const [data, setData] = useState(null);
    return (
        <div className='formular' style={{ paddingBottom: 64 }}>
            <div className='formular-headline'>
                Ihre Anfrage wurde erfolgreich verarbeitet
            </div>
            <div className='finish-icons'>
                <div className='finish-icon'>
                    <img src={Mail}></img>
                    <div style={{ fontWeight: "bold" }}>
                        1. Sichten und Verträge anfordern
                    </div>
                    <div style={{ textAlign: "center" }}>
                        Sie erhalten in wenigen Minuten eine Zusammenfassung
                        Ihrer Anfrage. Klicken Sie in dieser E-Mail auf "Meine
                        Dokumente anfordern", um alle wichtigen
                        Vertragsdokumente anzufordern.
                    </div>
                </div>
                <div className='finish-icon'>
                    <img src={Sign}></img>
                    <div style={{ fontWeight: "bold" }}>
                        2. Verträge unterzeichnen
                    </div>
                    <div style={{ textAlign: "center" }}>
                        Sie erhalten eine E-Mail von der Firma DocuSign, mit
                        welcher Sie die Vertragsdokumente aufrufen und
                        unterzeichnen können. Alternativ können Sie dort die
                        Verträge herunterladen und analog unterzeichnen.
                    </div>
                </div>
                <div className='finish-icon'>
                    <img src={Car}></img>
                    <div style={{ fontWeight: "bold" }}>
                        3. Fahrzeug anmelden
                    </div>
                    <div style={{ textAlign: "center" }}>
                        Nachdem wir die Unterlagen unterschrieben erhalten
                        haben, lassen wir Ihnen in wenigen Tagen eine EVB Nummer
                        zukommen, die Sie zur Anmeldung Ihres Fahrzeugs
                        verwenden können.
                    </div>
                </div>
            </div>
        </div>
    );
}
